import { useContext } from "react";
import { AppContext } from "../App";
import { t } from "../i18n";

export const BookingHourSelection = ({ hours, selected, onSelect }) => {
	const { data } = useContext(AppContext);
	const labels = [t("Por la mañana"), t("Por la tarde")];
	const classSuffix = ["morning", "afternoon"];

	const allUnavailable = hours?.every(
		(group) =>
			!group ||
			group.length === 0 ||
			group.every((slot) => !slot.available)
	);

	if (allUnavailable) {
		return (
			<div className="content_time_info no-availability">
				<h4>{t("No se han podido cargar las horas disponibles")}</h4>
				<p>
					{t(
						"Por favor, intenta de nuevo más tarde o contáctanos para ayudarte a gestionar tu cita."
					)}
				</p>
			</div>
		);
	}

	return (
		<div className="content_time">
			<div className="content_time_info">
				<h4>
					<img src="resources/icons/timer.svg" alt="Elegir hora" />
					<span>
						{data.damageArea === "repair"
							? t("Listo en tan solo 30 minutos")
							: data.damageGlass.includes("Lateral")
							? t("Sustitución en 2 horas aproximadamente")
							: t("Sustitución en 2,5 horas aproximadamente")}
					</span>
				</h4>
				<p>
					{data.damageArea === "repair"
						? t(
								"Puedes esperar cómodamente en nuestra recepción mientras revisamos tu vehículo."
						  )
						: t(
								"Déjalo a la hora que elijas y sé puntual para evitar esperas."
						  )}
				</p>
			</div>

			{hours?.map((hourGroup, index) => {
				const hasAvailable = hourGroup?.some((slot) => slot.available);

				return (
					<div
						key={index}
						className={`content_time_${classSuffix[index]}`}
					>
						<p className="content_time_header">{labels[index]}</p>
						{hourGroup?.length > 0 && hasAvailable ? (
							<div className="content_time_slots">
								{hourGroup.map((hour, hourIndex) => {
									const value =
										hour.dropoff + "-" + hour.pickup;
									const isSelected = selected === value;
									return (
										<span
											key={hourIndex}
											className={`kensei_03${
												isSelected ? " selected" : ""
											}${
												!hour.available
													? " disabled"
													: ""
											}`}
											onPointerDown={onSelect(hour)}
										>
											{hour.dropoff}
										</span>
									);
								})}
							</div>
						) : (
							<p className="no-availability">
								{t(
									"No hay horas disponibles para este horario."
								)}
							</p>
						)}
					</div>
				);
			})}
		</div>
	);
};
